import styled from 'styled-components';

export default function RefundTransferDot({ pending = true, receipt = false }: { pending?: boolean; receipt?: boolean }) {
  return <Dot role="img" aria-label={receipt ? '현금영수증 취소 대기' : pending ? '환불 송금 대기' : '무통장 환불 처리 대기'}
    title={receipt ? '취소 확인이 필요한 현금영수증이 있습니다.' : pending ? '고객에게 송금할 환불이 있습니다.' : '처리할 무통장 환불 접수가 있습니다.'} />;
}

const Dot = styled.span`
  display: inline-block; flex: 0 0 auto; width: var(--space-2); height: var(--space-2);
  margin-inline: var(--space-1); border-radius: var(--radius-pill); background: var(--color-text-danger);
  vertical-align: middle; position:relative; top:calc(var(--space-1) * -1);
`;
